<template>
    <b-modal id="corporate-contact-modal" size="lg" scrollable title="Invoiced Account Inquiry" hide-footer centered>
        <div class="container">
            <div class="mb-0">
                Opening an Invoiced Account simply means:
            </div>
            <ul class="pl-3">
                <li>You would like to be invoiced instead of paying with a credit card as you go.</li>
                <li>The way that works is you pre-purchase credits & pre-pay via an invoice.</li>
                <li>Our credits never expire and 1 Credit = $1.</li>
                <li>Choose a one-off amount you might want to be pre-billed for below.</li>
                <li>One of our team members will then be in touch to discuss further.</li>
            </ul>
            <form class="auth-form" @submit.prevent="sendContact" @keydown="form.onKeydown($event)">
                <div class="form-row">
                    <div class="form-group col-sm-12 col-md-6">
                        <label class="required">First Name</label>
                        <input v-model="form.first_name" :class="{ 'is-invalid': form.errors.has('first_name') }" type="text" name="first_name" class="form-control">
                        <has-error :form="form" field="first_name"/>
                    </div>
                    <div class="form-group col-sm-12 col-md-6">
                        <label class="required">Last Name</label>
                        <input v-model="form.last_name" :class="{ 'is-invalid': form.errors.has('last_name') }" type="text" name="last_name" class="form-control">
                        <has-error :form="form" field="last_name"/>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-sm-12 col-md-6">
                        <label class="required">Email</label>
                        <input v-model="form.email" :class="{ 'is-invalid': form.errors.has('email') }" type="text" name="email" class="form-control">
                        <has-error :form="form" field="email"/>
                    </div>
                    <div class="form-group col-sm-12 col-md-6">
                        <label class="required">Company</label>
                        <input v-model="form.company" :class="{ 'is-invalid': form.errors.has('company') }" type="text" name="company" class="form-control">
                        <has-error :form="form" field="company"/>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-sm-12">
                        <label class="required">Pre-purchase amount <i>(You are not committing to be invoiced)</i></label>
                        <b-form-select v-model="form['pre-purchase_amount']" :options="preAmts" :class="{ 'is-invalid': form.errors.has('pre-purchase_amount') }" name="pre-purchase_amount" class="form-control"/>
                        <has-error :form="form" field="pre-purchase_amount"/>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-sm-12">
                        <v-button variant="primary" class="float-right btn-lg" :loading="form.busy">
                            Submit
                        </v-button>
                    </div>
                </div>
            </form>
        </div>
    </b-modal>
</template>

<script>
import Form from 'vform'
import { mapGetters } from 'vuex'

export default {
    name: 'CorporateModal',
    data () {
        return {
            form: new Form({
                first_name: '',
                last_name: '',
                email: '',
                company: '',
                'pre-purchase_amount': null
            }),
            preAmts: [
                { text: '' },
                { text: '$1,000+gst (Gives you 10% off all assets)', value: '$1,000+gst (Gives you 10% off all assets)' },
                { text: '$2,000+gst (Gives you 15% off all assets)', value: '$2,000+gst (Gives you 15% off all assets)' },
                { text: '$3,000+gst (Gives you 20% off all assets)', value: '$3,000+gst (Gives you 20% off all assets)' },
                { text: 'Custom amount', value: 'Custom amount' },
                { text: 'I\'m not sure', value: 'I\'m not sure' }
            ]
        }
    },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            industries: 'data/industries'
        })
    },
    watch: {
        user (newUser, oldUser) {
            this.setUserFields()
        }
    },
    mounted () {
        this.setUserFields()
    },
    methods: {
        setUserFields () {
            if (this.user) {
                this.form.name = `${this.user.first_name} ${this.user.last_name}`
                this.form.email = this.user.email
            }
        },
        async sendContact () {
            const _this = this
            await this.form.post('/contact/corporate').then((data) => {
                _this.form.message = ''
                this.$toast.success('Thank you for contacting us! We will be in touch soon')

                this.$gtag.event('corporate_account_inquiry_submitted', {})

                this.$bvModal.hide('corporate-contact-modal')
            }).catch((error) => {
                console.log(error)
            })
        }
    }
}
</script>
